import { Avatar, Button, Dropdown, Flex, Layout, Tooltip, type MenuProps } from 'antd';
import { ArrowLeftOutlined, HomeOutlined } from '@ant-design/icons';
import { Fragment, useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Settings, Key, LogOut, Menu } from 'lucide-react';
import { CGButton } from '@martech-solution/utils/components';
import urlPath from 'src/constants/urlPath/urlPath';
import { AppContext } from 'src/contexts/app.context';
import ChangePassword from 'src/pages/Config/ChangePassword';
import Config from 'src/pages/v2/Config/Setting';
import styles from './Header.module.scss';
import Notification from './Notification';
import AdaptiveHorizontalMenu from '../HorizontalMenu/AdaptiveHorizontalMenu';

const { Header: HeaderAntd } = Layout;

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openChangePassword, setOpenChangePassword] = useState<boolean>(false);
  const [openConfig, setOpenConfig] = useState<boolean>(false);
  const { setIsSidebarCollapsed, isSidebarCollapsed } = useContext(AppContext);
  const isHome = location.pathname === '/' || location.pathname === '/erp';
  const { userInfo } = useContext(AppContext);
  const items: MenuProps['items'] = [
    {
      key: '2',
      onClick: () => setOpenConfig(true),
      label: (
        <div className={styles['header__act-auth-item']}>
          <Settings size={16} color='#64748b' />
          <span>Cài đặt</span>
        </div>
      )
    },
    {
      key: '3',
      onClick: () => {
        handleChangePassword();
      },
      label: (
        <div className={styles['header__act-auth-item']}>
          <Key size={16} color='#64748b' />
          <span>Thay đổi mật khẩu</span>
        </div>
      )
    },
    {
      key: '4',
      onClick: () => {
        handleLogout();
      },
      label: (
        <div className={styles['header__act-auth-item']}>
          <LogOut size={16} color='#64748b' />
          <span>Đăng xuất</span>
        </div>
      )
    }
  ];

  const handleChangePassword = () => {
    setOpenChangePassword(true);
  };
  const handleLogout = async () => {
    const returnUrl = window.location.pathname;
    localStorage.setItem('returnUrl', returnUrl);
    navigate(urlPath.signoutOidc.location);
  };

  const handleToggleSidebar = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };
  const formatNameLetter = (fullName: string | undefined) => {
    if (!fullName) return '';

    return fullName[0].toUpperCase();
  };

  return (
    <Fragment>
      <HeaderAntd className={styles.header}>
        <div className={styles.header__brand}>
          {location.pathname !== '/' && location.pathname !== '/erp' && (
            <Flex align='center' gap={10}>
              <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)} />
              <Button icon={<HomeOutlined />} onClick={() => navigate('/')} />
            </Flex>
          )}

          <div className={styles['header__brand-text']}>
            <span className={styles['header__brand-title']}>ERP</span>
            <span className={styles['header__brand-subtitle']}>Business Solution</span>
          </div>
          {!isHome && (
            <Tooltip title={isSidebarCollapsed ? 'Mở menu' : 'Đóng menu'}>
              <CGButton
                type='text'
                size='small'
                className={styles['header__menu-toggle']}
                onClick={handleToggleSidebar}
                icon={<Menu size={20} />}
                style={{
                  padding: '8px',
                  minWidth: 'auto',
                  height: 'auto'
                }}
              />
            </Tooltip>
          )}
        </div>
        {/* Center the menu */}
        <div className={styles['header__center-menu']}>
          <AdaptiveHorizontalMenu maxVisibleItems={3} />
        </div>
        <Flex gap={30} align='center'>
          <Notification />
          <Dropdown menu={{ items }} trigger={['click']} arrow={false}>
            <div className={styles['header__act-auth']}>
              <div className={styles['header__act-auth-left']}>
                {/* <Icon url={User} size={16} /> */}
                <Avatar size={32} className={styles['header__act-auth-avatar']}>
                  {formatNameLetter(userInfo?.fullName)}
                </Avatar>
                <span className={styles['header__act-auth-name']}>{userInfo?.fullName}</span>
              </div>
            </div>
          </Dropdown>{' '}
        </Flex>
      </HeaderAntd>

      <ChangePassword open={openChangePassword} setOpen={setOpenChangePassword} />
      <Config open={openConfig} setOpen={setOpenConfig} />
    </Fragment>
  );
};

export default Header;
